/**
 * Frog Posters — contrôleur des cartes produit.
 *
 * Chargé une seule fois par le layout, il pilote toutes les cartes de la page par
 * délégation d'évènements. C'est indispensable : les sections chargées en AJAX
 * (produits suggérés, filtres de collection, quick add) arrivent par innerHTML, et
 * un <script> inséré de cette façon ne s'exécute jamais. Ici, aucune initialisation
 * par carte n'est nécessaire — une carte qui apparaît plus tard fonctionne aussitôt.
 *
 * À charger depuis layout/theme.liquid :
 *   <script src="{{ 'custom-product-card.js' | asset_url }}" defer></script>
 */
(function () {
  var routes = (window.Theme && window.Theme.routes) || {};
  var CART_ADD_URL = routes.cart_add_url || '/cart/add';
  var CART_URL = routes.cart_url || '/cart';
  var eventsModule = null;

  function q(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function paintPricing(card, data) {
    var onSale = data.hasCompare === 'true';
    var priceEl = q(card, '[data-frog-price]');
    var compareEl = q(card, '[data-frog-compare]');
    var promoEl = q(card, '[data-frog-promo]');

    if (priceEl) priceEl.textContent = data.price;
    if (compareEl) {
      compareEl.textContent = data.comparePrice;
      compareEl.classList.toggle('is-hidden', !onSale);
    }
    if (promoEl) {
      promoEl.textContent = onSale ? '\u2212' + data.discount + '%' : '';
      promoEl.classList.toggle('is-hidden', !onSale);
    }
  }

  function ctaLabel(card) {
    var button = q(card, '[data-frog-add]');
    var current = q(card, '.frog-card__swatch.is-selected');
    if (!button) return '';
    if (!current) return button.dataset.labelAdd;
    if (current.dataset.available !== 'true') return button.dataset.labelSoldOut;
    return current.dataset.hasCompare === 'true' ? button.dataset.labelSale : button.dataset.labelAdd;
  }

  function swatchFrom(event) {
    var target = event.target;
    return target && target.closest ? target.closest('.frog-card__swatch') : null;
  }

  // --------- Survol : aperçu du prix de la taille survolée ---------

  document.addEventListener('mouseover', function (event) {
    var swatch = swatchFrom(event);
    if (!swatch) return;
    var card = swatch.closest('.frog-card');
    if (card) paintPricing(card, swatch.dataset);
  });

  document.addEventListener('mouseout', function (event) {
    var swatch = swatchFrom(event);
    if (!swatch) return;
    var card = swatch.closest('.frog-card');
    var current = q(card, '.frog-card__swatch.is-selected');
    if (current) paintPricing(card, current.dataset);
  });

  // --------- Clic : sélection de la taille, image et prix ---------

  document.addEventListener('click', function (event) {
    var swatch = swatchFrom(event);
    if (!swatch) return;
    var card = swatch.closest('.frog-card');
    if (!card) return;

    card.querySelectorAll('.frog-card__swatch').forEach(function (s) {
      s.classList.remove('is-selected');
      s.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('is-selected');
    swatch.setAttribute('aria-pressed', 'true');

    var input = q(card, '[data-frog-variant-input]');
    if (input) input.value = swatch.dataset.variantId;

    paintPricing(card, swatch.dataset);

    var img = q(card, '[data-frog-img]');
    if (img && swatch.dataset.image) {
      img.src = swatch.dataset.image;
      if (swatch.dataset.srcset) img.srcset = swatch.dataset.srcset;
    }

    var button = q(card, '[data-frog-add]');
    if (button) {
      button.disabled = swatch.dataset.available !== 'true';
      button.textContent = ctaLabel(card);
    }
  });

  // --------- Ajout au panier ---------
  // Le drawer d'Horizon n'écoute qu'une chose : le CartLinesUpdateEvent de
  // '@shopify/events'. Son contenu est rendu par <cart-items-component>, rafraîchi via
  // sa méthode publique fetchCartData(). Le module n'est chargé qu'au premier ajout.

  function loadEvents() {
    if (eventsModule) return Promise.resolve(eventsModule);
    return import('@shopify/events')
      .catch(function () {
        return import('@theme/events');
      })
      .then(function (mod) {
        eventsModule = mod;
        return mod;
      })
      .catch(function () {
        return null;
      });
  }

  function sectionsToRender() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (node) {
      if (node.dataset.sectionId) ids.push(node.dataset.sectionId);
    });
    return ids;
  }

  function refreshCart() {
    var component = document.querySelector('cart-items-component');

    if (component) {
      return customElements.whenDefined('cart-items-component').then(function () {
        if (typeof component.fetchCartData === 'function') return component.fetchCartData();
        return fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
          return r.json();
        });
      });
    }

    return fetch(CART_URL + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json();
    });
  }

  function openDrawerIfNeeded() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || drawer.hasAttribute('auto-open')) return;

    var themeDrawer = drawer.closest('theme-drawer');
    if (themeDrawer && typeof themeDrawer.open === 'function' && !themeDrawer.isOpen) {
      themeDrawer.open();
    }
  }

  document.addEventListener('submit', async function (event) {
    var form = event.target.closest ? event.target.closest('[data-frog-form]') : null;
    if (!form) return;
    event.preventDefault();

    var card = form.closest('.frog-card');
    var button = q(form, '[data-frog-add]');
    var input = q(form, '[data-frog-variant-input]');
    if (!button || button.disabled || !input) return;

    var variantId = input.value;
    if (card) card.classList.add('is-loading');
    button.disabled = true;
    var existingError = q(form, '.frog-card__error');
    if (existingError) existingError.remove();

    var mod = await loadEvents();
    var CartLinesUpdateEvent = mod && mod.CartLinesUpdateEvent;
    var deferred = null;

    if (CartLinesUpdateEvent) {
      deferred = CartLinesUpdateEvent.createPromise();
      (card || form).dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: variantId, quantity: 1 }],
          promise: deferred.promise
        })
      );
    }

    try {
      var body = new FormData();
      body.append('id', variantId);
      body.append('quantity', '1');
      var ids = sectionsToRender();
      if (ids.length) body.append('sections', ids.join(','));

      var response = await fetch(CART_ADD_URL, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        body: body
      });
      var payload = await response.json();
      if (payload.status) {
        throw new Error(payload.description || payload.message || button.dataset.labelError);
      }

      var cart = await refreshCart();

      if (deferred) {
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            items: cart.items,
            source: 'frog-product-card',
            itemCount: 1,
            productId: button.dataset.productId,
            sections: payload.sections,
            didError: false
          }
        });
      } else {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: { cart: cart, data: { source: 'frog-product-card', itemCount: cart.item_count } }
          })
        );
      }

      openDrawerIfNeeded();

      button.textContent = button.dataset.labelAdded + ' \u2713';
      setTimeout(function () {
        button.textContent = ctaLabel(card);
      }, 2000);
    } catch (error) {
      if (deferred) deferred.reject(error);
      var message = document.createElement('p');
      message.className = 'frog-card__error';
      message.setAttribute('role', 'alert');
      message.textContent = error.message || button.dataset.labelError;
      form.appendChild(message);
    } finally {
      if (card) card.classList.remove('is-loading');
      button.disabled = false;
    }
  });
})();
